module.exports = __webpack_public_path__ + "img/RTI_DM.50a2f4fe.png";